<template>
    <div class="general-modal">
        <BaseModal :padding="isMobileOrTablet ? MODAL_PADDING_MOBILE : MODAL_PADDING_DESKTOP"
                   maxWidth="400px"
                   maxHeight="500px"
                   useClickOutsideClose
                   @close="handleClose">
            <template #header/>
            <template #content>
                <div class="general-modal__content">
                    <div class="general-modal__image">
                        <img :src="(asset_cdn('assets/missions/in-game-images/motivation-char-assets/failrow1.svg') as string)"
                             :alt="errorMessage.subtitle"
                             :title="errorMessage.subtitle">
                    </div>
                    <div class="general-modal__subtitle">
                        {{ errorMessage.subtitle }}
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="general-modal__actions">
                    <span class="general-modal__action general-modal__action--confirm">
                        <BaseButton @click="handleClose">
                            {{ errorMessage.buttonText }}
                        </BaseButton>
                    </span>
                </div>
            </template>
        </BaseModal>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, reactive } from 'vue';
    import BaseModal from '@/js/components/BaseModal.vue';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useModalActive } from '@/js/composables/useModalActive';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import BaseButton from '@/js/components/BaseButton.vue';
    import { asset_cdn } from '@/js/helpers/helpers';
    import { deleteCookie, getCookieValue } from '@/js/helpers/cookieHelpers';
    import { COOKIES_KEYS } from '@/js/quests/game/constants/cookiesKeys';
    import { MODAL_PADDING_DESKTOP, MODAL_PADDING_MOBILE } from '@/js/quests/global/constants/modal';

    const modalStore = useModalStore();
    const { isMobileOrTablet } = useDeviceSize();

    const errorMessage = reactive({
        subtitle: '',
        buttonText: '',
    });

    const setErrorMessage = (message: {subtitle: string, buttonText: string}) => {
        errorMessage.subtitle = message.subtitle || '';
        errorMessage.buttonText = message.buttonText || '';
    };

    const handleClose = () => {
        modalStore.toggleModal(ModalEnum.CUSTOM_ERROR, false);
    };

    onMounted(() => {
        const message = JSON.parse(getCookieValue(COOKIES_KEYS.CUSTOM_ERROR_MODAL) || '{}');
        const isMessageEmpty = Object.keys(message).length === 0;

        if (isMessageEmpty) {
            return;
        }

        setErrorMessage(message);
        deleteCookie(COOKIES_KEYS.CUSTOM_ERROR_MODAL);
    });

    useModalActive();
</script>

<style scoped lang="scss">
@use "@/sass/design-system/variables" as variables;
@use "@/sass/partials/breakpoints" as breakpoints;
@use "@/js/quests/dashboard/sass/mixins/_modal" as modalMixins;

.general-modal {
    @include modalMixins.modal;

    &__image {
        img {
            width: 150px;

            @media (max-width: breakpoints.$md-breakpoint-max-width) {
                width: 100px;
            }
        }
    }

    &__subtitle {
        color: variables.$baseWhite;
    }
}
</style>
